import { render, staticRenderFns } from "./videoScale.vue?vue&type=template&id=fe71215c&scoped=true"
import script from "./videoScale.vue?vue&type=script&lang=js"
export * from "./videoScale.vue?vue&type=script&lang=js"
import style0 from "./videoScale.vue?vue&type=style&index=0&id=fe71215c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe71215c",
  null
  
)

export default component.exports